<template>
	<div id="Stores" class="stores">
		<stores-component
			ref="storesComponent"
			:enableActiveNewStore="true"
			:enableActiveNewStoreRack="true"
			:enableActiveNewStoreRackSide="true"
			:enableActiveNewStoreRackSideModule="true">
		</stores-component>

		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import stores from '@/mixins/stores'

	import StoresComponent from '@/components/StoresComponent.vue'

	export default {
		name: 'Stores',
		mixins: [axiosAction, errors, mixin, stores],
		data() {
			return {
				storeId: 0,
				storeRackId: 0,
				storeRackModuleId: 0,
				searching: false,
				value: '',
			}
		},
		components: {
			'stores-component': StoresComponent,
		},
		computed: {
		},
		methods: {
			initModuleLocal() {
				this.setTitleModule('Bodegas y Modulos')
				this.setSubTitleModule('')
				//this.getAllStoresLocal()
			},
			getAllStoresLocal() {
				this.searching = true
				this.value = 'bodegas'
				this.getAllStores()
			},
			getAllStoresResultLocal(response) {
				if(response.data.success == true) {
					this.value = 'racks'
					this.getAllStoreRacks()
				} else {
					this.searching = false
				}
			},
			getAllStoreRacksResultLocal(response) {
				if(response.data.success == true) {
					this.value = 'modulos'
					this.getAllStoreRackModules()
				} else {
					this.searching = false
				}
			},
			getAllStoreRackModulesResultLocal(response) {
				this.searching = false
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllStoresResult': this.getAllStoresResult(response); break;				
					case 'getAllStoreRacksResult': this.getAllStoreRacksResult(response); break;				
					case 'getAllStoreRackModulesResult': this.getAllStoreRackModulesResult(response); break;				
					case 'saveStoreResult': this.saveStoreResult(response); break;				
					case 'saveStoreRackResult': this.saveStoreRackResult(response); break;				
					case 'saveStoreRackModuleResult': this.saveStoreRackModuleResult(response); break;				
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveStoreLocal() {
				if(this.objectStore.name.trim().length > 2) {
					this.saveStore(this.objectStore)
				} else {
					this.$snotify.warning('Debe tener minimo 2 caracteres', 'OJO!!!')
				}
			},
			saveStoreResultLocal(response) {
				if(response.data.success == true) {
					this.listStores.push(response.data.data)
					this.clearObjectStore()
				}
			},
			saveStoreRackLocal(storeId) {
				if(this.objectStoreRack.name.trim().length > 0) {
					this.objectStoreRack.store_id = storeId
					this.saveStoreRack(this.objectStoreRack)
				} else {
					this.$snotify.warning('Debe ingresar algo', 'OJO!!!')
				}
			},
			saveStoreRackResultLocal(response) {
				if(response.data.success == true) {
					this.listStoreRacks.push(response.data.data)
					this.clearObjectStoreRack()
				}
			},
			saveStoreRackModuleLocal(storeId, rackId) {
				if(this.objectStoreRackModule.name.trim().length > 2) {
					this.objectStoreRackModule.store_id = storeId
					this.objectStoreRackModule.store_rack_id = rackId
					this.saveStoreRackModule(this.objectStoreRackModule)
				} else {
					this.$snotify.warning('Debe tener minimo 2 caracteres', 'OJO!!!')
				}
			},
			saveStoreRackModuleResultLocal(response) {
				if(response.data.success == true) {
					this.listStoreRackModules.push(response.data.data)
					this.clearObjectStoreRackModule()
				}
			},
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style scoped lang="scss">
	.ul-list-store {
		padding-left: 10px;
		li {
			ul {
				padding-left: 10px;
			}
		}
	}
</style>